import type React from 'react';

import type { IdHeaderTagDto, IdPlacementDto, IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { RequestErrorNotification } from 'src/hooks/useRequestErrorNotification.ts';

export interface TagDetailsRouteParams {
  integrationType: IntegrationType;
  headerTagId: IdHeaderTagDto;
  placementId?: IdPlacementDto;
}

export type ActionPopup<T> = {
  headerTagId: IdHeaderTagDto;
  setCurrentItems: React.Dispatch<React.SetStateAction<{ responseCode: 200; data: T; headers: null }>>;
  onFail: RequestErrorNotification;
};

export enum TagDetailsTab {
  placements = 'placements',
  changelog = 'changelog',
  rawScripts = 'raw-scripts',
  disableRules = 'disable-rules',
  dynamicPlacements = 'dynamic-placements',
  floorRule = 'floor-rule',
  floorExperiments = 'floor-experiments',
  live = 'live',
  logbook = 'logbook',
}

export enum PlacementDetailsTab {
  settings = 'settings',
  live = 'live',
}
